import { render, staticRenderFns } from "./StarInput.vue?vue&type=template&id=cf82148e&scoped=true"
import script from "./StarInput.vue?vue&type=script&lang=js"
export * from "./StarInput.vue?vue&type=script&lang=js"
import style0 from "./StarInput.vue?vue&type=style&index=0&id=cf82148e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf82148e",
  null
  
)

export default component.exports